<template>
  <div class="row col-12 cursor-pointer">


    <div class="col-12 col-sm-3 ms-0 mb-3 me-3">
      <Select :class="viewMode == true ? 'grayscale' : ''" v-model="selectedYear" id="yearSelector"
        icon="far fa-calendar-alt" label="* Año de aducción" :options="yearsList" valKey="name" textKey="name"
        @change="updateSelectedYear" :disabled="viewMode == true ? true : false" />
    </div>
    <div class="col-12 col-sm-3 ms-0 mb-3 ">

      <Select :class="viewMode == true ? 'grayscale' : ''" v-model="selectedCriteria" id="criteriaSelector"
        icon="fas fa-bezier-curve" label="* Criterio de optimización" :options="criteriaList" valKey="key"
        textKey="name" style="min-width: 275px" :disabled="viewMode == true ? true : false" />
    </div>

    <!-- Nuevo desplegable para Tipo de Año </div>-->


    <div class="col-6 col-sm-3 ms-5 mb-3">
      
    
      <SwitchBordered 
                  :label="'Año completo/desde hoy'"
                  :message="switchStatus"
                 v-if="this.$route.fullPath=='/newplan/preconfigure?reuseplan=true'"
                  v-model="interruptor" 
                  @change="sendDate"
                />
  </div>
  </div>

</template>


<script>
import { mapState, mapActions } from "vuex";
import PlannerService from "@/services/PlannerService";
import PrevisionService from "@/services/PrevisionService";
import Select from "@/components/commons/Select";
import SwitchBordered from "../../../../components/commons/SwitchBordered.vue";

export default {
  data() {
    return {
      selectedYear: null,
      yearsList: [],
      selectedCriteria: null,
      criteriaList: [],
      disponibility: [],
      startDateList: [],
      selectedStartDate: null,
      selectedYearType: null,
      yearTypeOptions: [],
      interruptor: false
    };
  },
  props: {
    viewMode: {
      type: Boolean,
      default: false,
    },
    reusePlan: {
      type: Boolean,
      default: false,
    },
    selectedCriteriaUpd: {
      type: String,
      default: null,
    },
  },
  components: {
    Select,
    SwitchBordered
  },
  watch: {
    selectedYear: function (newVal, oldVal) {
      if (newVal != null) {
        this.v_updSelectedYear(newVal);
      }
    },

    selectedCriteria: function (newVal, oldVal) {
      if (newVal != null) {
        this.v_updSelectedCriteria(newVal);
      }
    },

    startDate: function (newVal, oldVal) {
      if (newVal != null) {
        this.v_updSelectedStartDate(newVal);
      }
    },

    v_selectedYear: function (newVal, oldVal) {
      if (newVal != null && this.viewMode == true) {
        this.selectedYear = newVal;
      }
    },

    v_selectedCriteria: function (newVal, oldVal) {
      if (newVal != null && this.viewMode == true) {
        this.selectedCriteria = newVal;
      }
    },
    v_selectedYearType: function (newVal, oldVal) {
      if (newVal != null && this.viewMode == true) {
        this.selectedYearType = newVal;
      }
    },

    v_selectedStartDate: function (newVal, oldVal) {
      if (newVal != null && this.viewMode == true) {
        this.selectedStartDate = newVal;
      }
    },
    selectedCriteriaUpd: function (newVal, oldVal) {
      //console.log("nv", newVal)
      if (newVal != null) {
        this.selectedCriteria = newVal
      }
    },
  },
  computed: {
    ...mapState("planner", [
      "v_uuid",
      "v_selectedYear",
      "v_selectedCriteria",
      "v_selectedStartDate",
      "v_selectedYearType"
    ]),

    switchStatus: function () {
      return this.interruptor ? 'Desde hoy' : 'Todo el año';
    },
  },
  methods: {
    ...mapActions("planner", [
      "v_updSelectedYear",
      "v_updSelectedCriteria",
      "v_updSelectedStartDate",
      "v_updSelectedYearType"
    ]),
    updateSelectedYear() {
      this.v_updSelectedYear(this.selectedYear);
      //console.log("Valor seleccionado para Año:", this.selectedYear);
      this.sendDate();
    },
    updateYearType() {
      const selectedOption = this.yearTypeOptions.find(option => option.key === this.selectedYearType);
      this.v_updSelectedYearType(selectedOption);
      this.selectedYearDesdeFecha = selectedOption && selectedOption.desde_fecha;
      //console.log("Valor seleccionado para YearType:", this.selectedYearType);
      //console.log("Fecha asociada desde_fecha:", selectedOption?.desde_fecha); 
      // console.log(
      //   "Fecha asociada desde_fecha:",
      //   selectedOption //&& selectedOption.desde_fecha
      // );
    },
    sendDate() {
      this.$emit("sendDate", this.interruptor);
    },
  },
  async mounted() {
    /* Seleccionar elemento por defecto al cargar */
    let response_01 = await PlannerService.getFormsOptions();
    let response_02 = await PrevisionService.getYearsPrevActual();

    if (response_02.data) {
      // Populate selects
      this.yearsList = response_02.data;
      //Con este pop quitamos el ultimo año del select para que el usuario no pueda hacer planes sobre él, ya que al no
      //haber planes previos, el algoritmo no funcionará.
      this.yearsList.pop();     //

      // En caso de que el plan sea nuevo
      ////////////////////////////////////
      if (this.reusePlan != true || this.v_selectedYear == null) {
        // Select defaults
        this.selectedYear = await this.yearsList[0].name;
        // Lo guardamos reactivamente para que se popule por todos sitios


      } else {
        this.selectedYear = await this.v_selectedYear;

      }
    } else {
      console.log(
        "No se pudo obtener datos desde el backend. Contacte con el desarrollador"
      );
    }

    if (response_01.data) {
      // Populate selects
      this.criteriaList = response_01.data.criteria;
      this.startDateList = response_01.data.startDates;
      this.yearTypeOptions = response_01.data.type;
      //console.log("Contenido de response_01.data.type:", response_01.data.type);
      //console.log("Contenido de response_01.data.type fecha:", response_01.data.type.key); 
      // En caso de que el plan sea nuevo
      ////////////////////////////////////
      if (this.reusePlan != true || this.v_selectedCriteria == null) {
        // Select defaults
        this.selectedCriteria = await this.criteriaList[0].key;
        this.selectedStartDate = await this.startDateList[0].key;
        //this.selectedYearType = {desde_fecha: this.yearTypeOptions[0].desde_fecha,type:this.yearTypeOptions[0].key};
        this.selectedYearType = this.yearTypeOptions[0].key;
        // console.log("Valor:", this.yearTypeOptions[1].key);
        // console.log("Valor fecha:", this.yearTypeOptions[0].desde_fecha);
        // console.log("Valor detipo y fecha", this.selectedYearType)
        this.v_updSelectedYearType(this.yearTypeOptions[0]);
      } else {
        this.selectedCriteria = await this.v_selectedCriteria;
      }
    } else {
      console.log(
        "No se pudo obtener datos desde el backend. Contacte con el desarrollador"
      );
    }

    if (this.$route.fullPath == '/newplan/preconfigure'){
      this.interruptor=false
    }
    //this.updateSelectedYear();
    this.sendDate();

  },
};
</script>

<style scoped>
/* Sobreescribir configuraciones por defecto */
.card {
  max-width: 100%;
}

.nav-tabs .nav-link {
  color: gray;
  border: 0;
  border-bottom: 1px solid grey;
}

.nav-tabs .nav-link:hover {
  border: 0;
  border-bottom: 1px solid grey;
}

.nav-tabs .nav-link.active {
  color: #000000;
  border: 0;
  border-radius: 1;
  border-bottom: 2px solid #4ca1ef;
  background-color: #cde9ff;
}

.nav-item:hover {
  background-color: #f0f7fc;
  transition: background-color 0.5s ease;
}

.grayscale {
  opacity: 0.7;
  filter: grayscale(70%);
}

.form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333333;
}
</style>